<template>
    <div class='xbjl' v-if='kbxmlc'>
        <div :class='["box",kbxmlc.zt=="2"||role!="Z"?"noBtn":""]'>
            <div class='clear' v-if='role=="Z"'>
                <el-button type="primary" style="margin-right:10px" @click='editJl' v-show='!isEdit'>编辑</el-button>
                <el-button type="primary rt" style="margin-right:10px" @click='saveJl' v-show='isEdit'>保存</el-button>
            </div>
            <VueUeditorWrap v-show='isEdit' v-model='hcjlHtml' :config="editorConfig" class='jlContent'></VueUeditorWrap>
            <div class='jlContent' v-show='!isEdit' v-html='hcjlHtml'></div>
            <div id="bdtts_div_id"></div>
        </div>
        <el-button type='primary lcNext' @click='nextBtn' v-if='kbxmlc.zt!="2"&&role=="Z"' :disabled="waitLoading">下一步</el-button>
    </div>
    <div v-else class='loading'>
        <p>页面正在加载中...</p>
        <div id="colorfulPulse">
            <span class='item-1'></span>
            <span class='item-2'></span>
            <span class='item-3'></span>
            <span class='item-4'></span>
            <span class='item-5'></span>
            <span class='item-6'></span>
            <span class='item-7'></span>
        </div>
    </div>
</template>
<script>
import VueUeditorWrap from 'vue-ueditor-wrap'
export default {
    name:'xbjl',
    components:{
        VueUeditorWrap
    },
    data(){
        return{
            waitLoading:false,
            kbxmlc:'',
            djlcId:'',
            hcjlHtml:'',//会场纪律
            hcjl:'',
            role:localStorage.getItem('role')?localStorage.getItem('role'):'T',
            isEdit:false,//是否正在编辑
            editorConfig: {
                // 编辑器是否自动被内容撑高
                autoHeightEnabled: false,
                // 初始容器高度
                initialFrameHeight: '100%',
                // 初始容器宽度
                initialFrameWidth: '100%',
                // 调试完毕打包上线则切换回/static/UEditor/php/controller.php即可，不用做其他处理
                serverUrl:'/api/v2/ueditor/ueditorConfig',
                UEDITOR_HOME_URL: "/UEditor/", //UEditor资源文件的存放路径
                zIndex:9999,
                toolbars:[['bold',]],
                wordCount:false
            },
        }
    },
    methods:{
        getData(){
            let para={
                djlcId:this.djlcId,
            }
            this.$api.kbhcjl(para).then(res=>{
                if(res.data.meta.success){
                    this.hcjlHtml=res.data.data.hcjl;
                    this.hcjl=res.data.data.hcjlcwb;
                    this.kbxmlc=res.data.data.kbxmlc;
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
            }).catch(()=>{})
            
        },
        editJl(){
            this.isEdit=true;
        },
        saveJl(){
            let para={
                hcjl:this.hcjlHtml
            }
            this.waitLoading=true
            this.$api.saveKbhcjl(para).then(res=>{
                if(res.data.meta.success){
                    this.isEdit=false;
                    this.hcjl=res.data.data.hcjlcwb;
                    this.$message({
                        type:'success',
                        message:'保存成功！'
                    })
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
                this.waitLoading=false
            }).catch(()=>{})
        },
        nextBtn(){
            let para={
                falg:this.kbxmlc.ycdz
            }
            this.waitLoading=true
            this.$emit('nextBtn',para)
        },
    },
    mounted(){
        this.djlcId = this.$route.query.djlcId;
        this.getData();
    },
}
</script>
<style lang="less" scope>
    .xbjl{
        .el-icon-dzxd{
            width:17px;
            height:15px;
            background: url('../assets/images/lb.jpg') no-repeat center;
            position: relative;
            top:2px;
        }
        .el-radio{
            width: 70px;
        }
        .jlContent{
            margin-top:10px;
            height:calc(~'100% - 60px');
            overflow-y: auto;
            >.edui-default{
                height:100%;
                >.edui-default.edui-editor{
                    height:100%;
                }
            }
            .edui-default .edui-editor-iframeholder{
                height:calc(~ '100% - 60px') !important;
            }
        }
    }
</style>